import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import MenuButton from './MenuButton';
import MenuContent from './MenuContent';
import CardAlert from './CardAlert';
import SelectContent from './SelectContent';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import { AuthContext } from './signin/AuthContext';
import axios from 'axios';
import { useConfig } from './ConfigContext';

export default function SideMenuMobile({ open, toggleDrawer }) {
  const { username, email, avatar, setToken } = useContext(AuthContext);
  const { changes, saveConfig } = useConfig();
  const hasUnsaved = Object.keys(changes).length > 0;
  const [anchorEl, setAnchorEl] = useState(null);

  // Mapping für lesbare Feldnamen
  const labelMap = {
    temperatur_tag: 'Temperatur Tag',
    temperatur_nacht: 'Temperatur Nacht',
    luftfeuchte_tag: 'Luftfeuchte Tag',
    luftfeuchte_nacht: 'Luftfeuchte Nacht',
    abluft_max_intensity: 'Abluft Intensität',
    abweichung_luftfeuchte: 'Abweichung Luftfeuchte',
    max_light: 'Max. Lichtintensität',
    dauer: 'Dauer',
    sun_rise: 'Sonnenaufgang',
    sun_set: 'Sonnenuntergang',
  };

  const logMeOut = () => {
    axios.post('/logout')
      .then(() => {
        localStorage.setItem('authenticated', false);
        setToken(null);
      })
      .catch(err => console.error(err));
  };

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSave = () => {
    saveConfig();
    handleClose();
    toggleDrawer(false)();
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer(false)}
        sx={{
          [`& .${drawerClasses.paper}`]: {
            backgroundImage: 'none',
            backgroundColor: 'background.paper',
          },
        }}
      >
        <Stack sx={{ maxWidth: '70dvw', height: '100%' }}>
          <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
            <Stack direction="column" sx={{ gap:1, alignItems:'center', flexGrow:1, p:1 }}>
              <Avatar
                sizes="small"
                alt="Growr"
                src={avatar}
                sx={{ width:50, height:50 }}
              />
              <Typography variant="h6">{username}</Typography>
              <SelectContent />
              <MenuButton 
              showBadge={hasUnsaved}
              aria-label="Open notifications"
              onClick={handleOpen}
            >
              <NotificationsRoundedIcon />
            </MenuButton>
            </Stack>
            
          </Stack>

          <Divider />
          <Stack sx={{ flexGrow:1 }}>
            <MenuContent />
            <Divider />
          </Stack>

          {/* Notifications Popover */}
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
            transformOrigin={{ vertical:'top', horizontal:'left' }}
          >
            <Box sx={{ width: 280, p:2 }}>
              <List sx={{ p:0 }}>
                {hasUnsaved ? (
                  Object.entries(changes).map(([key, value]) => (
                    <ListItem key={key} disablePadding>
                      <ListItemText primary={`${labelMap[key] || key} geändert auf ${value}`} />
                    </ListItem>
                  ))
                ) : (
                  <ListItem disablePadding>
                    <ListItemText primary="Keine neuen Benachrichtigungen" />
                  </ListItem>
                )}
              </List>
              {hasUnsaved && (
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSave}
                  sx={{ mt:2 }}
                >
                  Alle Änderungen speichern
                </Button>
              )}
            </Box>
          </Popover>

          <CardAlert />
          <Stack sx={{ p:2 }}>
            <Button
              variant="outlined"
              onClick={logMeOut}
              fullWidth
              startIcon={<LogoutRoundedIcon />}
            >
              Logout
            </Button>
          </Stack>
        </Stack>
      </Drawer>
    </>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};
